import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalService } from "app/services/local.service";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  getConfigOrderStatusList() {
    throw new Error("Method not implemented.");
  }
  apiUrl = "";
  // JSON.parse(localStorage.getItem("client"))["apiUrl"] || environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }

  getInvoices(record, params): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    return this.http
      .post(this.apiUrl + "paystack/payments/list/" + record, params, {
        headers: headers,
      })
      .map((respoonse) => respoonse)
      .toPromise();
  }
  getOrderStatusList(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    return this.http
      .post(
        this.apiUrl + "aggregator/getCancelConfig",
        {},
        {
          headers: headers,
        },
      )
      .map((respoonse) => respoonse)
      .toPromise();
  }
  viewOrderCancellationDetails(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "aggregator/getOrderCancelConfig",
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  updateOrderCancellationDetails(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/updateOrderCancelConfig", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  refundsList(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/listing-analytics/refundListing", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getRefundData(id): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "aggregator/listing-analytics/getRefundData/" + id,
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  processRefund(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "order/processRefund/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  denyRefund(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "order/deniedRefund/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  /** Commission Configuration */

  commissionConfig(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "seller/setCommission", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getcommissionConfig(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "seller/getCommission",
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  faqLists(search: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "faq/getFaq", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  addfaq(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "faq/addNewFaq", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  updatefaq(id: any, data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "faq/updateFaq?faqID=" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  removeFaq(id: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "faq/removeFaq?faqID=" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Both for Creating and Updating Platform Config

  platformConfig(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/deliveryRadius/create", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Getting Details of Platform Config

  getplatformConfig(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "aggregator/deliveryRadius/get", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Saving Wallet Incentives Configuration

  createWalletIncentiveConfig(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/wallet/saveWalletInc", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Getting Wallet Incentives Configuration Data

  getWalletIncentiveConfig(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "aggregator/wallet/getWalletInc", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Add Manual Payout

  addPayout(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/addPayout", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  payoutHistory(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/payoutHistory", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getSelectedSellerInfo(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/selectedSeller", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getPaymentSettingDetails(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "aggregator/deliveryRadius/get", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  savePaymentSetting(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/updatePaymentGateway", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  createTestPayment(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/createTestPaymentLink", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //  petpooja integartion apis

  validatePetPoojaDetails(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/petpooja/validatePetPoojaDetails", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  listLibrary(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(environment.saasUrl + "library/listLibrary", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  assignLibraryToClient(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(environment.saasUrl + "library/assignLibraryToClient/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getTemplates(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(environment.saasUrl + "whatsapp/getWhatsappTemplates/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  listLibrariesByClient(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(environment.saasUrl + "library/listLibrariesByClient", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  sendTemplate(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(environment.saasUrl + "whatsapp/sendWhatsappTemplate/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getWhatsappStatus(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(environment.saasUrl + "whatsapp/getWhatsappStatus/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  GetMappingIds(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(environment.saasUrl + "whatsapp/getMappingIds", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getCitiesByCountryCode(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "seller/getCitiesByCountryCode/" + data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
}
